<template>
  <div>
    <el-form class="serach-form" :inline="true" :model="filters" size="small">
      <el-form-item class="select_btn_130">
        <el-select
          class="select_btn_style"
          v-model="filters.isRead"
          placeholder="学员查看状态"
        >
          <el-option
            v-for="(item, i) in readStatus"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn_140">
        <el-select
          class="select_btn_style"
          v-model="filters.isDownload"
          placeholder="学员下载状态"
        >
          <el-option
            v-for="(item, i) in downStatus"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn_140">
        <el-select
          class="select_btn_style"
          v-model="filters.liaisonIsDownload"
          placeholder="联络员下载状态"
        >
          <el-option
            v-for="(item, i) in downStatus"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="m-l-14">
        <el-input
          prefix-icon="el-icon-search"
          size="small"
          v-model.trim="filters.className"
          placeholder="班级名称"
        ></el-input>
      </el-form-item>
      <el-form-item class="m-l-14">
        <el-input
          prefix-icon="el-icon-search"
          size="small"
          v-model.trim="filters.userName"
          placeholder="姓名"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <butn btntype="primary" title="查询" @click="query"></butn>
        <butn title="重置" @click="reset" class="czButn"></butn>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import butn from "@/components/button/index";
import { getEnums } from "@/utils/common.js";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
      downStatus: [],
      readStatus: [],
    };
  },
  created() {
    getEnums(
      ["IS_READ", "IS_DOWNLOAD"],
      this,
      ["readStatus", "downStatus"],
      [true, true]
    );
  },
  methods: {
    query() {
      this.$emit("search", { ...this.filters });
    },
    reset() {
      this.filters = {};
      this.query();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>